const teamData = [
    {
      name: "Dr Avinash Shrikhande",
      role: "Principal, KaviKulguru Institute of Technology and Science, Ramtek",
      img: "https://www.kits.edu/assets/images/staff/photo-principal.JPG",
      // description:
      //   "Guiding the institute towards academic brilliance and technological advancements.",
      social: [ "fa-twitter", "fa-linkedin"]
    },
    {
      name: "Dr Pankaj Ashtankar",
      role: "Dean of Student Activities, HOD of Electronics & Communication",
      img: "https://i.ibb.co/DD1DjcFQ/1565420803107.jpg",
      // description:
      //   "Leading the way in student engagement and fostering academic excellence in the institution.",
      social: [ "fa-twitter", "fa-linkedin"]
    },
    {
      name: "Mr.Sanjay A.Borikar",
      role: "Convener Teknodeon'25, Assistant Professor Mech Engg Dept",
      img: "https://i.ibb.co/Jjb8zSdC/Sanjay-Borikar2.jpg",
      // description:
      //   "Leading the way in student engagement and fostering academic excellence in the institution.",
      social: [ "fa-twitter", "fa-linkedin"]
    },
    {
      name: "Zubair Sayyad",
      role: "Student Co-Ordinator",
      img: "https://i.ibb.co/4nZLP0Nv/Whats-App-Image-2025-02-10-at-23-28-36-b880dc7c.jpg",
      description:
        "Get Ready for Teknodeon’25",
      social: ["fa-github", "fa-twitter", "fa-linkedin"]
    },
    {
      name: "Vivek Yelkapelli",
      role: "Student Co-Ordinator",
      img: "https://i.ibb.co/jk0mH6f1/Whats-App-Image-2025-02-10-at-23-56-23-b0e4deaa.jpg",
      description:
        "The Wait is over! Tekno is here !!",
      social: ["fa-github", "fa-twitter", "fa-linkedin"]
    }
  ];
  
  export default teamData;
  